import React from 'react';
import { Container } from './styles';

const Footer: React.FC = () => (
  <Container>
    <p>ⓒ Entrevista | Front-End</p>
  </Container>
);

export default Footer;
